var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4898 7.90625L2.36484 0.414848C2.1436 0.290742 1.88983 0.236886 1.63726 0.260433C1.38468 0.283981 1.14525 0.383817 0.950762 0.54668C0.756276 0.709543 0.615943 0.927724 0.548407 1.17224C0.48087 1.41676 0.489325 1.67603 0.57265 1.91563L2.99452 8.9836C2.99421 8.98619 2.99421 8.98882 2.99452 8.99141C2.99409 8.994 2.99409 8.99664 2.99452 8.99922L0.57265 16.0828C0.50592 16.2713 0.485375 16.473 0.512739 16.6711C0.540103 16.8691 0.614578 17.0577 0.729913 17.2211C0.845248 17.3844 0.998077 17.5177 1.17557 17.6097C1.35307 17.7017 1.55005 17.7498 1.74999 17.75C1.96692 17.7495 2.18004 17.6929 2.36874 17.5859L15.4867 10.082C15.6802 9.97364 15.8414 9.81571 15.9537 9.62446C16.066 9.43321 16.1254 9.21552 16.1258 8.99372C16.1262 8.77193 16.0676 8.55403 15.956 8.36237C15.8443 8.17072 15.6837 8.01222 15.4906 7.90313L15.4898 7.90625ZM1.74999 16.5V16.493L4.10468 9.625H8.62499C8.79075 9.625 8.94973 9.55916 9.06694 9.44195C9.18415 9.32474 9.24999 9.16576 9.24999 9C9.24999 8.83424 9.18415 8.67527 9.06694 8.55806C8.94973 8.44085 8.79075 8.375 8.62499 8.375H4.11093L1.75468 1.50938L1.74999 1.5L14.875 8.98672L1.74999 16.5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.76792425d0090f87e04d40e771bd2a73.svg";
export { ForwardRef as ReactComponent };